import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "title", "image", "date", "label"];
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Featured = props => {
  var {
    title,
    image,
    date,
    label = "FEATURED"
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/_jsxs("div", {
    className: "relative flex flex-col bg-cover w-full  bg-no-repeat bg-center px-5 p-4 justify-end text-white overflow-hidden",
    style: {
      backgroundImage: "url(" + image + ")"
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: "absolute inset-0 w-full h-full bg-black opacity-30 z-0"
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative w-full text-2xl justify-self-start z-10",
      children: [/*#__PURE__*/_jsx("span", {
        className: "relative z-20 text-black",
        children: label
      }), /*#__PURE__*/_jsx("div", {
        className: "absolute   z-0",
        style: {
          top: " -203px",
          left: "-162px",
          height: "266px",
          rotate: " 85deg"
        },
        children: /*#__PURE__*/_jsx("svg", {
          className: "h-full",
          xmlns: "http://www.w3.org/2000/svg",
          version: "1.1",
          id: "Layer_1",
          x: "0px",
          y: "0px",
          width: "100%",
          viewBox: "0 0 791 683",
          enableBackground: "new 0 0 791 683",
          children: /*#__PURE__*/_jsx("path", {
            fill: "#FFD200",
            opacity: "1.000000",
            stroke: "none",
            d: " M27.314594,670.960876   C20.835442,670.508484 20.950457,665.415833 20.093328,661.462280   C17.264803,648.415649 14.371627,635.363220 12.217596,622.196167   C10.314761,610.564636 8.980474,598.806091 8.089339,587.051025   C6.742164,569.280151 5.689054,551.473877 5.094851,533.663208   C4.616118,519.313660 4.122329,504.869598 5.189458,490.583588   C7.308167,462.219727 10.910066,434.062592 17.683268,406.279877   C25.571617,373.923004 36.920979,343.024231 52.729568,313.784851   C63.160751,294.491455 75.146065,276.132111 89.835678,259.786743   C106.531921,241.208511 122.915703,222.225220 140.964935,205.022964   C158.161423,188.633423 176.662155,173.405380 195.809845,159.326416   C216.266495,144.284988 237.575821,130.186539 259.574463,117.520020   C281.463745,104.916481 304.468903,94.172638 327.352692,83.394516   C355.354523,70.205811 384.491882,59.776608 414.016876,50.556068   C445.861786,40.611034 478.081543,31.999872 510.928131,25.974283   C530.013184,22.473204 549.112366,18.996788 568.292297,16.081842   C584.473694,13.622598 600.764038,11.838508 617.037659,10.041009   C628.471924,8.778047 639.947083,7.813860 651.425903,7.044413   C664.444275,6.171774 677.480164,5.396170 690.520935,5.060173   C712.113281,4.503841 733.715698,4.090656 755.313660,4.102956   C766.010925,4.109049 776.707520,5.197353 787.093872,5.778649   C787.093872,19.073343 787.097229,31.950026 787.089722,44.826698   C787.088745,46.491444 787.110840,48.162056 786.987793,49.819977   C785.684387,67.384872 784.505432,84.960938 782.979309,102.506721   C781.899597,114.919868 780.675964,127.339592 778.902832,139.668091   C777.023499,152.735123 774.721252,165.760040 772.062195,178.692001   C767.604553,200.370682 763.182739,222.075516 757.895935,243.560211   C750.976135,271.680664 741.835815,299.122284 731.520386,326.217651   C721.859375,351.593872 710.518860,376.162933 697.866089,400.108398   C684.665466,425.090729 669.288940,448.735626 652.284973,471.363678   C635.632202,493.524506 617.036987,513.925842 596.634705,532.520447   C582.375793,545.515991 567.009094,557.421936 551.354797,568.731506   C526.426392,586.741089 499.501923,601.574585 471.676666,614.593872   C438.613922,630.063721 404.537018,643.009460 369.096954,651.973572   C346.552490,657.675842 323.897003,663.003113 301.138916,667.771179   C289.002472,670.313965 276.573975,671.604614 264.220856,672.937195   C246.257889,674.874878 228.263733,676.612061 210.245621,677.922485   C195.410263,679.001465 180.519211,679.303833 165.656494,680.025818   C162.561920,680.176147 159.484940,680.893616 156.397018,680.913757   C153.731873,680.931152 151.068634,680.108765 148.394272,680.036316   C133.297562,679.627441 118.166046,679.829041 103.107460,678.866760   C86.242409,677.789062 69.435860,675.756348 52.616974,674.012695   C44.311974,673.151733 36.036449,672.006409 27.314594,670.960876  z"
          })
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "text-3xl md:text-4xl z-10 pt-14 ",
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: "text-lg z-10 pb-5 pb-14",
      children: date
    })]
  });
};
//# sourceMappingURL=featured.js.map